import type { Category } from '@/mocks/comics';

interface CategoryTabsProps {
  categories: Category[];
  activeCategory: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ categories, activeCategory, onSelect }: CategoryTabsProps) {
  return (
    <section className="py-8">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1.5 overflow-x-auto scrollbar-hide pb-1">
          {categories.map(cat => (
            <button
              key={cat.slug}
              type="button"
              onClick={() => onSelect(cat.slug)}
              className={`flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}